// Turns an article [faq] block into an accordion (WAI-ARIA APG pattern).
// The server renders plain H3 questions with their answers visible, so the
// FAQ stays readable without JavaScript. This script puts each question inside
// a real <button> that keeps its heading level, and collapses the answers.
// Collapsed answers use hidden="until-found", so find-in-page still reaches
// them and opens the item.

class ArticleFaq extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';

    for (const item of this.querySelectorAll('.bc-faq__item')) {
      const heading = item.querySelector('.bc-faq__question');
      const answer = item.querySelector('.bc-faq__answer');
      if (!heading || !answer || heading.querySelector('button')) continue;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'bc-faq__toggle';
      button.id = `${answer.id}-q`;
      button.setAttribute('aria-controls', answer.id);

      const label = document.createElement('span');
      label.className = 'bc-faq__label';
      label.append(...heading.childNodes);
      const icon = document.createElement('span');
      icon.className = 'bc-faq__icon';
      icon.setAttribute('aria-hidden', 'true');
      button.append(label, icon);
      heading.append(button);

      this.#set(button, answer, false);
      button.addEventListener('click', () => this.#set(button, answer, button.getAttribute('aria-expanded') !== 'true'));
      answer.addEventListener('beforematch', () => this.#set(button, answer, true));
    }
  }

  #set(button, answer, open) {
    button.setAttribute('aria-expanded', String(open));
    if (open) answer.removeAttribute('hidden');
    else answer.setAttribute('hidden', 'until-found');
  }
}

if (!customElements.get('bc-faq')) customElements.define('bc-faq', ArticleFaq);
